import { element } from 'protractor';
import { IFlightDetails, ITicketsHoldObject } from './flightDetails';
import { HttpClient } from '@angular/common/http';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IFlight } from './../flight';
import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { environment } from '../../../environments/environment';


@Component({
  selector: 'app-flight-details',
  templateUrl: './flight-details.component.html',
  styleUrls: ['./flight-details.component.css']
})
export class FlightDetailsComponent implements OnInit, OnDestroy {

  flight: IFlight;
  flightDetails: IFlightDetails;

  getFlightDetailsInterval = null;

  constructor(private activeModal: NgbActiveModal, private _http: HttpClient) { }

  ngOnInit() {
    this.getFlightDetailsInterval = setInterval(() => {
      this.getFlightData();
    }, 1000);
  }

  setFlight(flight: IFlight) {
    this.flight = flight;
  }

  getFlightData() {
    this._http.get(environment.flightDetailsUrl + '?fid=' + this.flight.id)
        .subscribe(
          data => {
            const flightDetails: IFlightDetails = {
              total: data['total'],
              taken: data['taken'],
              onlineTaken: data['onlineTaken'],
              onlineTotal: data['onlineTotal'],
              available: data['available'],
              onlineAvailable: data['onlineAvailable'],
              systemHolds: [],
              websiteHolds: []
            };

            data['holds'].forEach(item => {
              const hold: ITicketsHoldObject = {
                amount: item['amount'],
                holder: item['holder'],
                lastUpdatedTime: item['lastUpdatedTime'],
                type: item['type']
              };

              if (item['type'] === 'system') {
                flightDetails.systemHolds.push(hold);
              } else {
                flightDetails.websiteHolds.push(hold);
              }
            });

            this.flightDetails = flightDetails;
          },
          error => {},
          () => {}
        );
  }

  ngOnDestroy() {
    clearInterval(this.getFlightDetailsInterval);
  }

  closeActiveModal() {
    this.activeModal.close();
  }
}


// WEBPACK FOOTER //
// ./src/app/flights/details/flight-details.component.ts